<main role="main">
  <h2 role="heading" class="text-center" attr.aria-label="{{ 'employerModal.title' | translate }}">
    {{ "employerModal.title" | translate }}</h2>

  <form [formGroup]="employerForm" focusInvalidInput role="form">
    <fieldset>
      <label class="mt-4" for="abc">{{ "employerModal.employerName" | translate }} :
      </label>
     
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0"
        [ngClass]="displayFieldCss(employerForm, 'employerName')&& issubmitForm">
        <input type="text" maxlength="250" formControlName="employerName"
          (blur)="trimpaces('employerName')" aria-required="true" name="employerName" autofocus>
      </div>
     
      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'employerName' ,true) && issubmitForm"
        role="alert" errorMsg="{{ 'errors.required' | translate }} {{ 'employerModal.employerName' | translate }}"
        attr.aria-label="{{ 'errors.required' | translate }} {{ 'employerModal.employerName' | translate }}">
      </app-field-error-display>
     
      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'employerName',false)" role="alert"
        errorMsg="{{ 'errors.charactersError' | translate }}  {{ 'employerModal.employerName' | translate }}"
        attr.aria-label="{{ 'errors.charactersError' | translate }} {{ 'employerModal.employerName' | translate }}">
      </app-field-error-display>

      <label class="mt-4" for="employerAddress"
        attr.aria-label="{{'employerModal.employerAddress' | translate }}">{{ "employerModal.employerAddress" | translate }}
      </label>

      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0">

        <textarea matInput type="text" formControlName="employerAddress" maxlength="250" autocorrect="off"
          autocapitalize="off" spellcheck="off" #employerAddress
          (keyup.enter)="myinuptcountrylist.focus()" aria-required="false" name="employerAddress"
          placeholder="{{ 'personalInformation.enterALocation' | translate }}">
          
        </textarea>

        <label class="mt-4" for="country"
          attr.aria-label="{{'personalInformation.country' | translate }}">{{ "personalInformation.country" | translate }} :
        </label>

      </div>
      
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0" [ngClass]="displayFieldCss(employerForm, 'country')">
          <select formControlName="country" (change)=checkCountry() #myinuptcountrylist aria-required="true"
            [attr.aria-invalid]="isFieldTouched(employerForm, 'country')" name="country">
            <option *ngFor="let country of countryList" [ngValue]="country.id">{{country.countryName}}</option>
          </select>
        </div>

        <app-field-error-display [displayError]="isFieldTouched(employerForm, 'country')" role="alert"
          errorMsg="{{ 'errors.required' | translate }} {{ 'personalInformation.country' | translate }}"
          attr.aria-label="{{ 'errors.required' | translate }} {{ 'personalInformation.country' | translate }}">
        </app-field-error-display>

        <label class="mt-4" *ngIf="isCanadaOrUsa" for="provinceState"
          attr.aria-label="{{'personalInformation.provinceState' | translate }}">{{ "personalInformation.provinceState" | translate }} :
        </label>

        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0" *ngIf="isCanadaOrUsa"
          [ngClass]="displayFieldCss(employerForm, 'provinceState')">
          <select formControlName="provinceState" name="provinceState" aria-required="true"
            [attr.aria-invalid]="isFieldTouched(employerForm, 'provinceState',true)">
            <option *ngFor="let province of provinceList" [ngValue]="province.id">{{province.provinceName}}
            </option>
          </select>
        </div>

        <app-field-error-display [displayError]="isFieldTouched(employerForm, 'provinceState',true)" role="alert"
          errorMsg="{{ 'errors.required' | translate }} {{ 'personalInformation.provinceState' | translate }}"
          attr.aria-label="{{ 'errors.required' | translate }} {{ 'personalInformation.provinceState' | translate }}">
        </app-field-error-display>

        <app-field-error-display [displayError]="isFieldTouched(employerForm, 'provinceState',false)" role="alert"
          errorMsg="{{ 'errors.invalidProvinceState' | translate }}">
        </app-field-error-display>


        <label class="mt-4" for="employerPhoneNumber"
          attr.aria-label="{{'employerModal.employerPhone' | translate }}">{{ "employerModal.employerPhone" | translate }}
        </label>

      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0" 
        [ngClass]="displayFieldCss(employerForm, 'employerPhoneNumber')">
        <app-intl-tel-input [cssClass]="'custom'" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
          [searchCountryFlag]="true" [selectFirstCountry]="false" [maxLength]="16" [separateDialCode]="true" [phoneValidation]="true"
          [inputId]="'employerPhoneNumber'" name="employerPhoneNumber"
          [attr.aria-invalid]="isFieldTouched(employerForm, 'employerPhoneNumber')"
          [selectedCountryISO]="this.employerForm.get('country')?.value" formControlName="employerPhoneNumber">
        </app-intl-tel-input>
      </div>

      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'employerPhoneNumber')" role="alert"
        errorMsg="{{ 'errors.invalidPhone' | translate }}" attr.aria-label="{{ 'errors.invalidPhone' | translate }}">
      </app-field-error-display>

      <label class="mt-4">{{ "employerModal.employerStillInBusiness" | translate }}</label>

      <div role="group" attr.aria-label="{{ 'employerModal.employerStillInBusiness' | translate }}">
        <ul class="mb-0" [ngClass]="displayFieldCss(employerForm, 'stillInBusiness')">
          <li>
            <label for="stillInBusinessYes">
              <input type="radio" id="stillInBusinessYes" name="stillInBusiness" [value]="true"
                formControlName="stillInBusiness" attr.aria-label="{{ 'employerModal.yes' | translate }}"
                aria-required="true" aria-invalid="isFieldTouched(employerForm, 'stillInBusiness')">
              {{ "employerModal.yes" | translate }}
            </label>
          </li>
          <li>
            <label for="stillInBusinessNo">
              <input type="radio" id="stillInBusinessNo" name="stillInBusiness" [value]="false"
                formControlName="stillInBusiness" attr.aria-label="{{ 'employerModal.no' | translate }}"
                aria-required="true" aria-invalid="isFieldTouched(employerForm, 'stillInBusiness')">
              {{ "employerModal.no" | translate }}
            </label>
          </li>
        </ul>
      </div>
      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'stillInBusiness')" role="alert"
        errorMsg="{{ 'errors.required' | translate }} {{ 'employerModal.employerStillInBusiness' | translate }}"
        attr.aria-label="{{ 'errors.required' | translate }} {{ 'employerModal.employerStillInBusiness' }}">
      </app-field-error-display>

      <label class="mt-4" for="jobTitle"
        attr.aria-label="{{'employerModal.occupation' | translate }}">{{ "employerModal.occupation" | translate }}
        :</label>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0" [ngClass]="displayFieldCss(employerForm, 'jobTitle')">
        <input type="text" maxlength="50" formControlName="jobTitle" (blur)="trimpaces('jobTitle')"
          aria-required="true" name="jobTitle" [attr.aria-invalid]="isFieldTouched(employerForm, 'jobTitle',true)">
      </div>
      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'jobTitle',true)" role="alert"
        errorMsg="{{ 'errors.required' | translate }} {{ 'employerModal.occupation' | translate }}"
        attr.aria-label="{{ 'errors.required' | translate }} {{ 'employerModal.occupation' | translate }}">
      </app-field-error-display>

      <app-field-error-display [displayError]="isFieldTouched(employerForm, 'jobTitle',false)" role="alert"
        errorMsg="{{ 'errors.charactersError' | translate }}  {{ 'employerModal.occupation' | translate }}"
        attr.aria-label="{{ 'errors.charactersError' | translate }} {{ 'employerModal.occupation' | translate }}">
      </app-field-error-display>

      <label class="mt-4 mb-0" for="employedFrom"
        attr.aria-label="{{'employerModal.employedFrom' | translate }}">{{ "employerModal.employedFrom" | translate }}
        :</label><br>
      <label class="hint"
        attr.aria-label="{{ 'employerModal.datePlaceHolder' | translate }}">{{ "employerModal.datePlaceHolder" | translate }}</label>


      <div class="d-flex col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0">
        <input [matDatepicker]="employedFrom" (dateChange)="setBusinessMinimumDate($event)" [max]="maxDate" [min]="minYear"
          formControlName="employedFrom" type="text" style="margin-right: -40px;"
          autocomplete="off"
          [attr.aria-invalid]="datePickerValidationCheck(employerForm, 'employedFrom', 'any')"
          aria-required="true" name="employedFrom">
        <mat-datepicker-toggle  style="margin-top: -6px;" matSuffix [for]="employedFrom"></mat-datepicker-toggle>
        <mat-datepicker #employedFrom startView="year"></mat-datepicker>
      </div>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedFrom', 'required')" role="alert"
        errorMsg="{{'errors.employedStart.required' | translate }}">
      </app-field-error-display>

      <app-field-error-display role="alert"
        [displayError]="datePickerValidationCheck(employerForm, 'employedFrom', 'matDatepickerParse')" 
        errorMsg="{{ 'errors.employedStart.format' | translate }}">
      </app-field-error-display>

      <app-field-error-display role="alert"
        [displayError]="datePickerValidationCheck(employerForm, 'employedFrom', 'matDatepickerMin')"
        role="alert" errorMsg="{{'errors.employedStart.pre1900' | translate }}">
      </app-field-error-display>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedFrom', 'matDatepickerMax')"
        errorMsg="{{ 'errors.employedStart.future' | translate }}">
      </app-field-error-display>

      <app-field-error-display role="alert"
        [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'startEndError')"
        errorMsg="{{ 'errors.employedStart.endBeforeStart' | translate }}">
      </app-field-error-display>


      <label class="mt-2 mb-0" for="employedTo"
        attr.aria-label="{{'employerModal.employedTo' | translate }}">{{ "employerModal.employedTo" | translate }}
        :</label><br>
      <label class="hint"
        attr.aria-label="{{ 'employerModal.datePlaceHolder' | translate }}">{{ "employerModal.datePlaceHolder" | translate }}</label>

      <div class="d-flex col-xl-6 col-lg-6 col-md-12 col-sm-12 pl-0">
        <input [matDatepicker]="employedTo" [min]="employedToMinimumDate"
          [max]="maxDate" formControlName="employedTo" type="text" style="margin-right: -40px;"
          [attr.aria-invalid]="datePickerValidationCheck(employerForm, 'employedTo', 'any')" aria-required="true" autocomplete="off"
          name="employedTo">
        <mat-datepicker-toggle style="margin-top: -6px;" matSuffix [for]="employedTo"></mat-datepicker-toggle>
        <mat-datepicker #employedTo startView="year"></mat-datepicker>
      </div>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'required')" role="alert"
        errorMsg="{{ 'errors.employedEnd.required' | translate }}">
      </app-field-error-display>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'matDatepickerParse')"
        role="alert" errorMsg="{{'errors.employedEnd.format' | translate }}">
      </app-field-error-display>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'matDatepickerMin') "
        role="alert" errorMsg="{{'errors.employedEnd.pre1900' | translate }}">
      </app-field-error-display>

      <app-field-error-display
        [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'matDatepickerMax')"
        errorMsg="{{ 'errors.employedEnd.future' | translate }}">
      </app-field-error-display>

      <app-field-error-display [displayError]="datePickerValidationCheck(employerForm, 'employedTo', 'startEndError')"
        role="alert" errorMsg="{{'errors.employedEnd.endBeforeStart' | translate }}">
      </app-field-error-display>

      <ng-container *ngTemplateOutlet="toolsList"></ng-container>

      <div class="row justify-content-center mt-5">

        <!-- <button class="btn btn-wsib" data-dismiss="modal" -->
        <button class="btn btn-wsib" [disabled]="!istoolform || greterthantwentyfor || lowerthanZero || isNumber"
          attr.aria-label="{{ 'employerModal.ok' | translate }}"
          (click)="addOrUpdatePastEmploymentInfo();">{{ "employerModal.ok" | translate }}</button>

      </div>
      <div class="row justify-content-center my-5">
        <button class="btn btn-wizard " #cancelBtn (click)="cancelEmploymentInfo()"
          attr.aria-label="{{ 'employerModal.title' | translate }} {{ 'employerModal.cancel' | translate }}"
          data-dismiss="modal"><b>{{ "employerModal.cancel" | translate }}</b></button>
      </div>
    </fieldset>
  </form>


  <ng-template #toolsList>

    <label class="mt-4"
      attr.aria-label="{{ 'employerModal.listOfToolsUsed' | translate }}">{{ "employerModal.listOfToolsUsed" | translate }}</label>

    <div class="table-responsive-sm mb-n2">
      <table class="table">
          <thead>
          <tr>
            <th class="table-header-set" scope="col" width="50%"
              attr.aria-label="{{ 'employerModal.toolsUsed' | translate }}">{{ "employerModal.toolsUsed" | translate }}
            </th>
            <th class="table-header-set" scope="col" width="25%"
              attr.aria-label="{{ 'employerModal.toolHoursPerDay' | translate }}">
              {{ "employerModal.toolHoursPerDay" | translate }}</th>
            <th class="table-header-set" scope="col" width="25%"
              attr.aria-label="{{ 'employerModal.action' | translate }}">{{ "employerModal.action" | translate }}</th>
          </tr>
        </thead>
      </table>
    </div>

    <div class="tool-list-wrapper" *ngFor="let item of tools ">


      <div class="add-tool-name-wrapper">
        <div class="bordered-label add-tool-name" attr.aria-label="{{ item.toolName }}">{{item.toolName}}</div>
      </div>

      <div class="hour-margin">
        <div class="bordered-label add-tool-hour" attr.aria-label="{{ item.hoursUsed }}">
          {{item.hoursUsed }}
        </div>
      </div>

      <div style="margin-top: 10px;" class="add-remove-button-wrap">
        <button class="btn btn-wizard" role="button" (click)="onToolsListdelete(item)"
          attr.aria-label="{{ 'employerModal.listOfToolsUsed' | translate }} {{ 'employerModal.remove' | translate }}">{{ "employerModal.remove" | translate }}</button>
      </div>
    </div>
    <hr style="margin-top: 50px;">
    <form [formGroup]="toolsForm" (ngSubmit)="onToolsListSubmit()" role="form" focusInvalidInput>
   <!-- <div *ngIf="!predefinedToolList?.length" class="spinner-border" style="margin-left: 19%;" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
      <fieldset *ngIf="tools?.length <= 9">

        <div class="add-row">
          <div class="add-tool-name-wrapper">

            <!-- <mat-form-field floatLabel="never" class="tool-name">
                <input type="text" matInput [formControl]="toolInput" (input)="isInvalidtool($event.target.value)"
                  [matAutocomplete]="auto" maxlength="100" formControlName="toolName">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let tool of filteredOptions | async" [value]="tool">
                    {{ tool }}
                  </mat-option>
                </mat-autocomplete>
  
                <app-field-error-display [displayError]="!toolsForm.get('toolName').valid && issubmit"
                  errorMsg="{{ 'errors.toolName' | translate }}">
                </app-field-error-display>
  
              </mat-form-field> -->


                <input type="text" attr.aria-label="{{ 'employerModal.toolsUsed' | translate }}" id="toolsEquipmentUsed"
                  matInput [formControl]="toolInput" (input)="isInvalidtool($event.target.value)" maxlength="250"
                  [matAutocomplete]="auto" class="add-tool-name">
                <mat-autocomplete #auto="matAutocomplete" aria-required="true">
                  <mat-option *ngFor="let tool of filteredOptions | async" [value]="tool" class="wrap-text">
                    {{ tool }}
                  </mat-option>
                </mat-autocomplete>
              <span class="hide-element">{{ "employerModal.toolsUsed" | translate }}</span>
          </div>

          <div class="hour-margin">
              <input type="text" matInput maxlength="5" (input)="isInValidHrs($event.target.value)"
                formControlName="hoursUsed" aria-required="true"
                attr.aria-label="{{ 'employerModal.toolHoursPerDay' | translate }}"
                aria-invalid="isFieldTouched(toolsForm, 'hoursUsed') && isNumber" class="add-tool-hour">

              <!-- [ngClass]="displayFieldCss(toolsForm, 'hoursUsed')" -->

              <app-field-error-display [displayError]="(!toolsForm.get('hoursUsed').valid && issubmit)" role="alert"
                errorMsg="{{ 'errors.hoursUsed' | translate }}" attr.aria-label="{{ 'errors.hoursUsed' | translate }}" class="add-tool-hour">
              </app-field-error-display>

              <!-- <app-field-error-display [displayError]="isFieldTouched(toolsForm, 'hoursUsed') && isNumber" role="alert"
                errorMsg="{{ 'errors.invalidNumberinHour' | translate }}"
                attr.aria-label="{{ 'errors.invalidNumberinHour' | translate }}">
              </app-field-error-display> -->

              <app-field-error-display [displayError]="isNumber" role="alert"
                errorMsg="{{ 'errors.invalidNumberinHour' | translate }}"
                attr.aria-label="{{ 'errors.invalidNumberinHour' | translate }}" class="add-tool-hour">
              </app-field-error-display>

              <app-field-error-display [displayError]="greterthantwentyfor" role="alert"
                errorMsg="{{  'errors.valueGrater' | translate }}"
                attr.aria-label="{{ 'errors.valueGrater' | translate }}" class="add-tool-hour">
              </app-field-error-display>
              <app-field-error-display [displayError]="lowerthanZero" errorMsg="{{  'errors.valueLower' | translate }}"
                role="alert" attr.aria-label="{{ 'errors.valueLower' | translate }}" class="add-tool-hour">
              </app-field-error-display>

          </div>

          <div style="margin-top: 10px;" *ngIf="tools?.length < 9" class="add-remove-button-wrap">
            <button class="btn btn-wizard" type="submit" role="button"
              attr.aria-label="{{ 'employerModal.listOfToolsUsed' | translate }} {{ 'employerModal.add' | translate }}"><b>{{ "employerModal.add" | translate }}</b></button>
          </div>
        </div>
        <app-field-error-display [displayError]="toolListOverLimit" errorMsg="{{ 'errors.maxTools' | translate }}"
          role="alert" attr.aria-label="{{ 'errors.maxTools' | translate }}">
        </app-field-error-display>


        <!-- [ngClass]="(10 >= this.tools.length) ? 'd-none' : ''" -->
        
      </fieldset>

    </form>

  </ng-template>